export default "__VITE_ASSET__CfvwBD_4__"